<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-07 10:35:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-19 18:05:22
-->
<template>
	<div class="userInfoBox">
		<div class="flex flex-align-center info-box">
			<div>
				<yx-avatar :size="56" :src="row.head"></yx-avatar>
			</div>
			<div class="ml-10 flex-column flex-just-between">
				<p class="flex flex-align-center">
					<platform-icon :platformId="row.platform_id" class="mr-8"></platform-icon>
					<span class="font-bold yx-color-text-primary">{{ row.anchor_name | formatEmpty }}</span>
					<LevelTag v-if="row.anchor_level" class="ml-4" :lv="row.anchor_level" />
				</p>
				<p class="fz-12 yx-color-text-secondary mt-4 flex flex-align-center">
					<span>{{ row.platform_id | formatPlatformName('unify') }}：</span>
					<span>{{ anchorAccount | formatEmpty }}</span>
					<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(anchorAccount)"></i>
				</p>
				<p class="fz-12 yx-color-text-secondary mt-2">粉丝数：{{ row.fans_num }}</p>
				<p class="fz-12 yx-color-text-secondary mt-4">达人招商：{{ row.nick_name | formatEmpty }}</p>
				<p class="fz-12 yx-color-text-secondary mt-2" v-if="is_good_type">带货类型：{{ row.sell_goods_desc | formatEmpty }}</p>
			</div>
		</div>
	</div>
</template>
<script>
import { copy } from '@/utils/common';
export default {
	props: {
		row: {
			type: Object,
			default: () => {},
		},
		is_good_type: {
			type: Number,
			default: () => 0,
		},
	},
	data() {
		return {};
	},
	computed: {
		anchorAccount() {
			//获取k抖音号，快手号，视频id
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.row.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.row.anchor_account,
				[dataMap.PLATFORM_SP.value]: this.row.anchor_uid,
			};
			return temPF[this.row.platform_id];
		},
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
	components: {},
};
</script>
<style lang="less" scoped>
.fan {
	padding: 0 4px 0 4px;
	height: 18px;
	line-height: 18px;
	border-radius: 2px;
	background: #fff6f2;
}
</style>
